import React, { useEffect, useState } from "react";
import { Modal, Spin } from "antd";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Skeleton from "@mui/material/Skeleton";
import ProductExpireTable from "../Tables/ProductExpiryTable";

const ProductExpiryModal = ({ open, onClose, id}) => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [expiryData, setExpiryData] = useState([]);
    const userData = useSelector((state) => state?.login?.user?.result);
  

  useEffect(() => {
    if (open && id) {
      GetProductExpiryData();
    }
  }, [open, id]);

 const GetProductExpiryData = async (limit, offset) => {
    const payload = {
      "company_id":userData?.company_id,
    "product_id": Number(id),
    "limit":limit,
    "offset":offset
    };
    try {
      const res = await axiosInstance.post(URLS.GET_PRODUCT_EXPIRY, payload);
      const res1 = res?.data;

      // console.log("res1---->", res1);

      if (res1?.result?.status_code === 200) {
        setExpiryData(res1?.result?.data);
      } else {
        setExpiryData([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  

  return (
<Modal
  open={open}
  onCancel={()=>{
    setExpiryData([]);
    onClose();
  }}
  footer={null}
  width={1400}
  height={700}
  centered
  closable={true}
  title={
    <div className="text-2xl font-semibold mb-7">
      {t("Expiry Details")}
    </div>
  }
>

  {loading ? (
   Array.from({ length: 4 }).map((_, index) => (
        <div
          key={index}
          className="flex px-4 py-3 border-b justify-between items-center"
        >
          <Skeleton height={50} width={300} />
          <Skeleton height={50} width={60} />
          <Skeleton height={50}  width={60}  />
        </div>
      ))
  ) : (
   <div className="mt-6 bg-white rounded-lg">
     <ProductExpireTable
                  additionalData={expiryData}
                  pagination={(values) => {
                    // setCurrentLimit(values.limit);
                    // setCurrentOffset(values.offset);
                    GetProductExpiryData(values.limit,values.offset);
                  }}
                /> 
              </div>
  )}
</Modal>

  );
};

export default ProductExpiryModal;
